import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataCzasPipe } from './data-czas.pipe';
import { DataPipe } from './data.pipe';
import { GwiazdkiPipe } from './gwiazdki.pipe';
import { OdmienDlaLiczbyPipe } from './odmienDlaLiczby/odmien-dla-liczby.pipe';
import { PoziomPipe } from './poziom.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    DataCzasPipe,
    DataPipe,
    PoziomPipe,
    GwiazdkiPipe,
    OdmienDlaLiczbyPipe,
  ],
  exports: [
    DataCzasPipe,
    DataPipe,
    PoziomPipe,
    GwiazdkiPipe,
    OdmienDlaLiczbyPipe,
  ],
  providers: [
    DatePipe,
    GwiazdkiPipe,
    OdmienDlaLiczbyPipe
  ]
})
export class SharedUtilModule { }
